import { render, staticRenderFns } from "./adminhome.vue?vue&type=template&id=dd439842&scoped=true&"
import script from "./adminhome.vue?vue&type=script&lang=js&"
export * from "./adminhome.vue?vue&type=script&lang=js&"
import style0 from "./adminhome.vue?vue&type=style&index=0&id=dd439842&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd439842",
  null
  
)

export default component.exports